<template>
    <v-app>
        <v-navigation-drawer 
                             v-if="isLoggedIn"
                             fixed
                             :mini-variant="miniVariant"
                             :clipped="clipped"
                             v-model="drawer"
                             app>
            <v-list>
                <v-list-tile value="true"
                             v-for="(menu, i) in menus"
                             :key="i"
                             :to="menu.to"
                             v-on:click.stop="drawer = !drawer"
                             v-if="menu.roles.includes(role)">
                    <v-list-tile-action>
                        <v-icon v-html="menu.icon"></v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title v-text="menu.title"></v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile value="true"
                             v-if="isLoggedIn"
                             v-on:click.stop="logOff()">
                    <v-list-tile-action>
                        <v-icon>exit_to_app</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>Desconectarse</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile value="true"
                             v-if="isLoggedIn">
                    <v-list-tile-action>
                        <v-icon>account_circle</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title v-text="(username) ? ('@' + username): ''"></v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>
        <v-toolbar class="animated bounceInDown" fixed app :clipped-left="clipped">
            <v-toolbar-side-icon v-if="isLoggedIn" v-show="isLoggedIn" v-on:click.stop="drawer = !drawer"></v-toolbar-side-icon>
            <!--<v-btn icon @click.stop="miniVariant = !miniVariant">
                <v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
            </v-btn>
            <v-btn icon @click.stop="clipped = !clipped">
                <v-icon>web</v-icon>
            </v-btn>-->
            <!--<v-btn icon @click.stop="fixed = !fixed">
                <v-icon>remove</v-icon>
            </v-btn>-->
            <img src="/public/img/de_logo.jpg" class="brand-logo" />
            <v-toolbar-title color="primary" v-html="title" class="hidden-xs-only"></v-toolbar-title>
            <!--<v-spacer></v-spacer>
            <v-btn icon @click.stop="rightDrawer = !rightDrawer">
                <v-icon>menu</v-icon>
            </v-btn>-->
        </v-toolbar>
        <v-content>
            <v-container fluid>
                <div color="primary" class="toolbar__title hidden-sm-and-up text-xs-center"><h5>Monitoría Cohorte Ajustada<br>Tasa de Graduación</h5></div>
                <router-view></router-view>
            </v-container>
        </v-content>
        <!--<v-navigation-drawer temporary
                             :right="right"
                             v-model="rightDrawer"
                             fixed>
            <v-list>
                <v-list-tile @click.native="right = !right">
                    <v-list-tile-action>
                        <v-icon>compare_arrows</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-title>Switch drawer (click me)</v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>-->
        <v-footer class="animated bounceInUp" :fixed="fixed" app>
            <v-spacer></v-spacer>
            <span>&copy; {{ currentYear }} Departamento de Educación de Puerto Rico</span>
            <v-spacer></v-spacer>
        </v-footer>
        <!-- Global Components Starts -->
        <modal ref="dialog"></modal>
        <confirm ref="confirm"></confirm>
        <snackbar ref="snackbar"></snackbar>
        <vue-progress-bar></vue-progress-bar>
        <!-- Global Components Ends -->
    </v-app>
</template>
<script>
    import script from './script'
    export default script
</script>



// WEBPACK FOOTER //
// src/App.vue